import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CatConceptosService } from "../../servicios/cat-conceptos.service";
import { CatEstatusService } from "../../servicios/cat-estatus.service";
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { Router } from "@angular/router";
import { CatConceptos, CatRequisitos, Aguas, Solicitudes, PersonaClientes, AguaBuscaCuentas, SolicitudRequisitos, SolicitudDetalles, AuxJasper, ParametroJasper } from "../../entidades/entidades"; // prettier-ignore
import { CatEstatus, EstadoCuentaInformacionInput, } from "../../entidades/entidades"; // prettier-ignore
import { CatConceptoCostos } from "../../entidades/entidades";
import { CatConceptoCostosService } from "../../servicios/cat-concepto-costos.service";
import { RConceptosRequisitosService } from "../../servicios/r-conceptos-requisitos.service";
import { RConceptosRequisitos } from "../../entidades/entidades";
import { CatRequisitosService } from "../../servicios/cat-requisitos.service";

import { PersonaClientesService } from "../../servicios/persona-clientes.service";
import { AguaBuscaCuentasService } from "../../servicios/agua-busca-cuentas.service";
import { SolicitudesService } from "../../servicios/solicitudes.service";
import { SolicitudRequisitosService } from "../../servicios/solicitud-requisitos.service";
import { SolicitudDetallesService } from "../../servicios/solicitud-detalles.service";

import { JasperService } from "./../../servicios/jasper.service";
import { AuthenticationService } from "app/servicios";
import { BuscaPersonaClientesService } from "../../servicios/busca-persona-clientes.service";
import { throwError } from "rxjs";
declare var $: any;

@Component({
  selector: "app-cat-conceptos",
  templateUrl: "./cat-conceptos.component.html",
  styleUrls: ["./cat-conceptos.component.css"],
})
export class CatConceptosComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catEstatus: CatEstatus[] = [];
  catConcepto: CatConceptos[] = [];
  catConceptoCostos: CatConceptoCostos[] = [];
  rConceptosRequisitos: RConceptosRequisitos[] = [];
  catRequisitos: CatRequisitos[] = [];

  datosAguaCuenta = new AguaBuscaCuentas();
  datosClientes = new PersonaClientes();
  datosSolicitud = new Solicitudes();
  datosDetalles = new Array<SolicitudDetalles>();
  datosRequisitos = new Array<SolicitudRequisitos>();

  datosPClientesForm: FormGroup;
  datosCuentaAguaForm: FormGroup;
  datosEnviaForm: FormGroup;
  listaServicios: any[] = [];
  flagMuestraC = false;
  flagMuestraD = false;
  requisitoUnico: any[] = [];
  currentUser: any;
  buscando: boolean = false;
  DatosRequisitos: any[] = [];
  selectedAll: any;
  public idrecibido: number;

  catConceptosForm: FormGroup;
  catConceptoCostosForm: FormGroup;
  rConceptosRequisitosForm: FormGroup;
  catRequisitosForm: FormGroup;

  public personaClientes$ = new EventEmitter<PersonaClientes>();
  public estadoCuentaInformacionInput$ = new EventEmitter<
    EstadoCuentaInformacionInput
  >();
  public estadoCuentaInformacionLimpio: EstadoCuentaInformacionInput;

  conceptoSeleccionado: number = 0;
  verSeleccion: number = 0;
  catConceptosTable: CatConceptos;
  public tableWidget: any;
  base64Url;
  private _jasperService: JasperService;
  @Input("catConceptos") catConceptos: CatConceptos;
  @Output("catConceptosOutput") catConceptosOutput: EventEmitter<CatConceptos>;
  public auxJasper: AuxJasper;
  display: boolean = false;
  showDialog() {
    this.display = true;
  }
  constructor(
    private formBuilder: FormBuilder,
    private catConceptosService: CatConceptosService,
    private catEstatusService: CatEstatusService,
    private catConceptoCostosService: CatConceptoCostosService,
    private rConceptosRequisitosService: RConceptosRequisitosService,
    private catRequisitosService: CatRequisitosService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,

    private personaClientesService: PersonaClientesService,
    private aguaBuscaCuentasService: AguaBuscaCuentasService,
    private solicitudesService: SolicitudesService,
    private solicitudRequisitosService: SolicitudRequisitosService,
    private solicitudDetallesService: SolicitudDetallesService,
    private buscaPersonaClientesService: BuscaPersonaClientesService,
    private jasp: JasperService,
    private router: Router
  ) {
    this.catConceptosOutput = new EventEmitter();
    this._jasperService = jasp;
  }

  ngOnInit() {
    this.getAllCatConceptos();
    this.catConceptosForm = this.formBuilder.group({
      id: [undefined],
      descripcion: [
        undefined,
        [Validators.required, Validators.maxLength(150)],
      ],
      cuentaContable: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      idGrupoConcepto: [undefined],
      idEstatus: [undefined],
      observaciones: [undefined, [Validators.maxLength(150)]],
      solicitable: [undefined],
      fechaIni: [undefined],
      fechaFin: [undefined],
    });

    this.datosPClientesForm = this.formBuilder.group({
      idPersonaCliente: [undefined],
      nRazonSocial: [undefined],
      domicilio: [undefined],
    });

    this.datosEnviaForm = this.formBuilder.group({
      observaciones: [undefined],
      total: [0],
    });

    if (this.catConceptos) this.catConceptosForm.patchValue(this.catConceptos);
    this.catConceptoCostosForm = this.formBuilder.group({
      id: [undefined],
      costoUmas: [0],
      idConcepto: [undefined],
      cantidad: [1],
      total: [0],
    });
    if (this.catConceptoCostos)
      this.catConceptoCostosForm.patchValue(this.catConceptoCostos);

    if (this.rConceptosRequisitos)
      this.catConceptosForm.patchValue(this.rConceptosRequisitos);
    this.rConceptosRequisitosForm = this.formBuilder.group({
      idRequisito: [undefined],
    });
    if (this.rConceptosRequisitos)
      this.rConceptosRequisitosForm.patchValue(this.rConceptosRequisitos);

    if (this.catConceptos) this.catRequisitosForm.patchValue(this.catConceptos);
    this.catRequisitosForm = this.formBuilder.group({
      id: [undefined],
      descripcion: [undefined],
    });
    if (this.catRequisitos)
      this.catRequisitosForm.patchValue(this.catRequisitos);
  }

  //====================================================
  //Componente Hijos
  //====================================================
  async childPersonaClientes(personaClientes: PersonaClientes) {
    console.log("TRAJO PC", personaClientes);
    this.datosPClientesForm.value.idPersonaCliente = personaClientes.id;
    this.buscaSolicitante();
  }

  async childAguaBuscaCuentas(idAgua: number) {
    debugger;
    if (!idAgua) {
      this.estadoCuentaInformacionInput$.emit(null);
      return;
    } else {
      this.datosSolicitud.idAgua = idAgua;
      //Carga formulario estado-cuentas
      let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
      estadoCuentaInformacionInput.idAgua = idAgua;
      //estadoCuentaInformacionInput.cuentaAgua = aguas.cuentaAgua;
      this.estadoCuentaInformacionInput$.emit(estadoCuentaInformacionInput);
    }
  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async guardarCatConceptos() {
    try {
      if (this.catConceptosForm.invalid) {
        throw new Error("No paso las validaciones.");
      }

      this.catConceptos = this.catConceptosForm.value;

      if (this.catConceptos.id) {
        this.updateCatConceptos(this.catConceptos);
      } else {
        this.catConceptos.id = 0;
        await this.addCatConceptos(this.catConceptos);
      }
      this.catConceptosOutput.emit(this.catConceptos);
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCatConceptos");
    }
  }

  recarga() {
    if (this.catConceptosForm.invalid) {
      throw new Error("No paso las validaciones.");
    }

    this.catConceptos = this.catConceptosForm.value;

    this.addCatConceptos(this.catConceptos);
  }

  //====================================================
  //Metodos para obtener datos especificos del concepto
  //====================================================
  async detalleConcepto(valor) {
    this.verSeleccion = this.conceptoSeleccionado;
    console.log(this.verSeleccion);
  }

  //====================================================
  // CatConceptos
  //====================================================

  async getCatConceptoCostos(id: number) {
    try {
      const datoRetorno = await this.catConceptoCostosService
        .getSingle(id)
        .toPromise();
      if (Object.keys(datoRetorno).length != 0) {
        console.log("Costos: ", datoRetorno);
        this.catConceptoCostosForm.patchValue(datoRetorno[0]);
      } else {
        this.catConceptoCostosForm.patchValue({
          costoUmas: [0],
          cantidad: [1],
          total: [0],
        });
        console.log("El concepto no trajo resultados de COSTOS");
      }
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      this.obtenCalculos();
      console.log("Paso por getCatConceptoCostos");
    }
  }

  //====================================================
  // RCatRequisitos
  //====================================================

  async getRConceptosRequisitos(id: number) {
    try {
      const datoRetorno = await this.rConceptosRequisitosService
        .getSingle(id)
        .toPromise();
      if (Object.keys(datoRetorno).length != 0) {
        this.rConceptosRequisitosForm.patchValue(datoRetorno);
        console.log("RConceptoRequisistos: ", datoRetorno);

        await this.getCatRequisitos(datoRetorno[0].idConcepto);
      } else {
        console.log("El concepto no trajo resultados de Requisitos");
      }
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getRConceptosRequisitos");
    }
  }

  //====================================================
  //  CatRequisitos
  //====================================================

  async getCatRequisitos(id: number) {
    try {
      const datoRetorno = await this.catRequisitosService
        .getSingle(id)
        .toPromise();

      if (Object.keys(datoRetorno).length != 0) {
        this.catRequisitosForm.patchValue(datoRetorno);
        const num1 = Object.keys(datoRetorno);

        for (let i = 0; i < num1.length; i++) {
          this.requisitoUnico.push(datoRetorno[i]);
          datoRetorno[i].repetido = false;
          this.DatosRequisitos.forEach((e) => {
            if (datoRetorno[i].id === e.id) {
              datoRetorno[i].repetido = true;
            }
          });

          if (datoRetorno[i].repetido == false) {
            datoRetorno[i].recibido = false;
            datoRetorno[i].cantidad = 1;
            this.DatosRequisitos.push(datoRetorno[i]);
            console.log("entra: ", datoRetorno[i].id);
          } else if (datoRetorno[i].repetido == true) {
            let index = this.DatosRequisitos.findIndex(
              (x) => x.id == datoRetorno[i].id
            );
            this.DatosRequisitos[index].cantidad++;
            console.log("repetido: ", datoRetorno[i].id);
          }
        }
      } else {
        this.requisitoUnico = [];
        this.muestraMensaje.notification(
          "No se encontraron registros.",
          "top",
          "center"
        );
      }
      this.obtenCalculos();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatRequisitos");
    }
  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async addCatConceptos(catConceptos) {
    try {
      const datoretorno = await this.catConceptosService
        .add(catConceptos)
        .toPromise();
      this.catConceptos = datoretorno;
      this.catConceptosTable = datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCatConceptos");
    }
  }

  async updateCatConceptos(catConceptos: CatConceptos) {
    try {
      const datoRetorno = await this.catConceptosService
        .update(catConceptos)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCatConceptos");
    }
  }

  async deleteCatConceptos(catConceptos: CatConceptos) {
    try {
      const datoRetorno = await this.catConceptosService
        .delete(catConceptos.id)
        .toPromise();
      this.getAllCatConceptos();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteCatConceptos");
    }
  }

  async getCatConceptos() {
    var id = this.conceptoSeleccionado;
    await console.log("ESTO id", id);
    try {
      const datoRetorno = await this.catConceptosService
        .getSingle(id)
        .toPromise();
      this.catConceptosForm.patchValue(datoRetorno);
      console.log("ESTOOOOOOOOOOO", datoRetorno);
      this.getCatConceptoCostos(id);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatConceptos");
    }
  }

  async getAllCatConceptos() {
    try {
      const datoRetorno = await this.catConceptosService
        .getBusquedas()
        .toPromise();
      this.catConcepto = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatConceptos");
    }
  }

  async getAllCatEstatus() {
    try {
      const datoRetorno = await this.catEstatusService.getAll().toPromise();
      this.catEstatus = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatEstatus");
    }
  }

  selectAll() {
    console.log("DATOS", this.DatosRequisitos);
    this.DatosRequisitos.forEach((e) => {
      if (e.recibido == true) {
        this.selectedAll = true;
        return;
      } else {
        this.selectedAll = false;
        return;
      }
    });
    console.log(this.selectedAll);

    if (this.selectedAll == true) {
      console.log("TRUE");
      for (var i = 0; i < this.DatosRequisitos.length; i++) {
        this.DatosRequisitos[i].recibido = false;
      }
    } else {
      console.log("FALSE");
      for (var i = 0; i < this.DatosRequisitos.length; i++) {
        this.DatosRequisitos[i].recibido = true;
      }
    }
    console.log("LISTA", this.DatosRequisitos);
  }

  checkout(index: number, row: any) {
    try {
      if (this.DatosRequisitos[index].recibido == false) {
        this.DatosRequisitos[index].recibido = true;
      } else if (this.DatosRequisitos[index].recibido == true) {
        this.DatosRequisitos[index].recibido = false;
      }
      console.log("Renglon: ", index, this.DatosRequisitos[index]);
    } catch (error) {
      throw error;
    }
  }

  //====================================================
  //Eventos BuscaPersonaClientes
  //====================================================

  async buscaSolicitante() {
    try {
      this.datosClientes.id = this.datosPClientesForm.value.idPersonaCliente;
      if (this.datosClientes.id == null) {
        this.muestraMensaje.error(
          "Ingresa un folio para la busqueda",
          "top",
          "center"
        );
        return;
      }
      console.log("AUTO", this.datosClientes.id);
      const datoretorno = await this.buscaPersonaClientesService
        .add(this.datosClientes)
        .toPromise();
      if (Object.keys(datoretorno).length != 0) {
        console.log("RETORNO: ", datoretorno);
        //DatosCliente
        this.datosSolicitud.idPersonaCliente = datoretorno[0].id;
        let nomRazon;
        if (datoretorno[0].nombreCliente.trim() != "") {
          nomRazon = datoretorno[0].nombreCliente.toString();
        } else {
          nomRazon = datoretorno[0].razonSocial.toString();
        }
        await this.datosPClientesForm.patchValue({
          idPersonaCliente: datoretorno[0].id,
          nRazonSocial: nomRazon,
          domicilio: datoretorno[0].domicilio,
        });
        this.muestraMensaje.notification(
          "Registro encontrado.",
          "top",
          "center"
        );
      } else {
        //DatosCliente
        this.datosSolicitud.idPersonaCliente = null;
        this.datosPClientesForm.reset();
        this.muestraMensaje.error("No se encontro registro.", "top", "center");
      }
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    }
  }

  async obtenCalculos() {
    var i1 = this.catConceptoCostosForm.value.costoUmas;
    var i2 = this.catConceptoCostosForm.value.cantidad;
    let i3 = i1 * i2;

    this.catConceptoCostosForm.patchValue({
      total: i3,
    });
    console.log("CALCULO: ", this.catConceptoCostosForm.value.total);

    var totalgral = 0;
    this.listaServicios.forEach((e) => {
      totalgral = totalgral + e.total;
    });

    console.log("TOTALGRAL: ", totalgral);
    if (totalgral >= 0) {
      console.log("TOTAL: ", this.datosEnviaForm.value.total);
      this.datosEnviaForm.patchValue({
        total: totalgral,
      });
    }
  }

  async agregaServicio() {
    try {
      this.obtenCalculos();
      this.requisitoUnico = [];
      let flagCheck = false;
      this.listaServicios.forEach((e) => {
        if (e.descripcion === this.catConceptosForm.value.descripcion) {
          flagCheck = true;
        }
      });
      if (
        this.catConceptoCostosForm.value.costoUmas != 0 &&
        flagCheck == false
      ) {
        let item = {
          descripcion: this.catConceptosForm.value.descripcion,
          cantidad: this.catConceptoCostosForm.value.cantidad,
          costoUmas: this.catConceptoCostosForm.value.costoUmas,
          idConcepto: this.catConceptoCostosForm.value.idConcepto,
          idConceptoCosto: this.catConceptoCostosForm.value.idConcepto,
          total: this.catConceptoCostosForm.value.total,
          requisitos: this.requisitoUnico,
        };
        this.listaServicios.push(item);
        //SolicitudDetalles
        let local = new SolicitudDetalles();
        local.costoUnitario = this.catConceptoCostosForm.value.costoUmas;
        local.cantidad = this.catConceptoCostosForm.value.cantidad;
        local.monto = this.catConceptoCostosForm.value.total;
        local.idConcepto = this.catConceptoCostosForm.value.idConcepto;
        local.idConceptoCosto = this.catConceptoCostosForm.value.id;
        this.datosDetalles.push(local);
        console.log("LISTAA: ", this.datosDetalles);
        //------------Requisitos------------
        var id = this.conceptoSeleccionado;
        console.log("ID", this.conceptoSeleccionado);
        this.getRConceptosRequisitos(id);
      } else if (this.catConceptoCostosForm.value.costoUmas != 0) {
        this.muestraMensaje.error("Servicio ya ingresado", "top", "center");
      } else {
        this.muestraMensaje.error(
          "Selecciona un servicio primero",
          "top",
          "center"
        );
      }
    } catch (error) {
      throw error;
    } finally {
      this.obtenCalculos();
    }
  }

  eliminaServicio(index: number, row: any) {
    try {
      console.log("Renglon seleccionado:", index, row);
      let local = row;
      //=============================================================
      //Elimina Servicio
      index = this.listaServicios.findIndex(
        (e) => e.idConcepto === row.idConcepto
      );
      if (index > -1) {
        this.listaServicios.splice(index, 1);
      }
      console.log("Asi quedo listaServicios", this.listaServicios);

      //=============================================================
      //Elimina datos Detalle
      //=============================================================
      for (let i = 0; i < this.datosDetalles.length; i++) {
        if (row.idConcepto == this.datosDetalles[i].idConcepto) {
          this.datosDetalles.splice(i, 1);
        }
      }
      console.log("Asi quedo datosDetalles", this.datosDetalles);

      //=============================================================
      //Elimina Requisitos
      //=============================================================
      if (Object.keys(this.listaServicios).length == 0) {
        this.DatosRequisitos.splice(0);
      } else {
        for (let i = 0; i < this.DatosRequisitos.length; i++) {
          local.requisitos.forEach((e) => {
            if (this.DatosRequisitos[i].id == e.id) {
              this.DatosRequisitos[i].cantidad--;
              if (this.DatosRequisitos[i].cantidad == 0) {
                this.DatosRequisitos.splice(i, 1);
              }
            }
          });
        }
      }
      console.log("Asi quedo DatosRequisitos", this.DatosRequisitos);
    } catch (error) {
      throw error;
    } finally {
      this.obtenCalculos();
    }
  }

  async guardaSolicitud() {
    if (this.buscando) {
      return;
    }
    try {
      let cuenta = "false";
      //Registro Solicitudes
      if (this.datosSolicitud.idPersonaCliente == null) {
        this.muestraMensaje.error("Selecciona un Solicitante", "top", "center");
        return;
      }

      if (Object.keys(this.listaServicios).length == 0) {
        this.muestraMensaje.error(
          "Selecciona Almenos un Servicio",
          "top",
          "center"
        );
        return;
 
      }

      this.datosDetalles.forEach((e) => {
        if (
          e.idConcepto == 1 ||
          e.idConcepto == 2 ||
          e.idConcepto == 3 ||
          e.idConcepto == 4
        ) {
          //No necesita cuenta Agua
        } else {
          //necesita cuenta Agua
          cuenta = "true";
              
     
        }
      });

      if (this.datosSolicitud.idAgua == null && cuenta == "true") {
        this.muestraMensaje.error(
          "Selecciona una Cuenta Agua",
          "top",
          "center"
        );
        return;
      }

      //Solicitudes
      this.datosSolicitud.observaciones = this.datosEnviaForm.value.observaciones;
      this.datosSolicitud.idUsuarioSolicito = this.authenticationService.currentUserValue.id;
      this.datosSolicitud.idConcepto = this.datosDetalles[0].idConcepto;
      console.log("Se ENVIAN Solicitudes", this.datosSolicitud);

      const datoretornoA = await this.solicitudesService
        .add(this.datosSolicitud)
        .toPromise();
      this.idrecibido = datoretornoA.id;

      //Solicitud Detalles
      console.log("Se ENVIAN Solicitud Detalles", this.datosDetalles);
      this.datosDetalles.forEach((e) => {
        e.idSolicitud = this.idrecibido;
      });
      const datoretornoB = await this.solicitudDetallesService
        .add(this.datosDetalles)
        .toPromise();

      //Solicitud Requisitos
      this.DatosRequisitos.forEach((e) => {
        const requisitos = new SolicitudRequisitos();
        requisitos.idRequisito = e.id;
        requisitos.recibido = e.recibido;
        requisitos.idSolicitud = this.idrecibido;
        this.datosRequisitos.push(requisitos);
      });

      console.log("Se ENVIAN Solicitud Detalles", this.datosRequisitos);
      const datoretornoC = await this.solicitudRequisitosService
        .add(this.datosRequisitos)
        .toPromise();

      await this.imprimeSolicitud();
    } catch (error) {
      throw error;
    } finally {
      
    }
  }

  async imprimeSolicitud() {
    console.log("Recibio Solicitud: ", this.idrecibido);
    this.auxJasper = new AuxJasper();
    this.auxJasper.JasperReport.nombreReporte = "Solicitud";
    this.auxJasper.JasperReport.tipo = "pdf";
    const parametroJasper = new ParametroJasper();
    parametroJasper.nombre = "id_solicitud";
    parametroJasper.valor = this.idrecibido + "";
    await this.auxJasper.ParametroJasper.push(parametroJasper);
    console.log("Agui va");
    await this.showDialog();
    await console.log("imprimeSolicitud");
  }
  
  onKeydown(event) 
  {
    if (event.key === "Enter") 
    {
      console.log('Evento enter');
      this.buscaSolicitante();
    }
  }




}
